import { isTag, isOneOfTags, isElementNode, isCommentNode } from 'anodum';
import { LIST_ELEMENTS, LIST_ITEM } from '../constants/editable-elements';
import isBlockElement from './is-block-element';
import isTextNodeWithSpacingOnly from './is-text-node-with-spacing-only';

const isElementChildNodesToWrap = (element) => {
  if (!isElementNode(element)) return false;
  const childNodes = Array.from(element.childNodes).filter(
    (node) => !(isCommentNode(node) || isTextNodeWithSpacingOnly(node))
  );

  return (
    isTag(element, LIST_ITEM) &&
    !childNodes.every((el) => isElementNode(el) && isOneOfTags(el, LIST_ELEMENTS)) &&
    !(childNodes.length === 1 && isBlockElement(childNodes[0]))
  );
};

export default isElementChildNodesToWrap;
